import React, { FC } from 'react';
import classNames from 'classnames/bind';
import UpcomingEventCard from '../UpcomingEventCard';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface Slot {
  timeInterval: string;
  startTime: number;
  endTime: number;
  date: string;
}
interface Offer {
  label: string;
  description: string;
  bannerImageURL: string;
}
interface User {
  name: string;
  mobile: string;
  uuid: string;
  rank: number;
}
interface UpcomingEventData {
  slot?: Slot;
  offer?: Offer;
  userList?: User[];
}
interface UpcomingEventProps {
  variant?: string;
  data?: UpcomingEventData[];
}

const getUpcomingEventsDom = (variant: string, data: UpcomingEventData[]): JSX.Element => {
  let className = 'stack';
  if (variant === 'slider') {
    className = 'slider';
  }
  return (
    <div className={cx(className)}>
      {data.map((eventItem, index) => {
        const { offer, slot } = eventItem;
        const { date, timeInterval, startTime, endTime } = slot;
        const { bannerImageURL, description, label } = offer;
        return (
          <div className={cx('event-card-container')} id={`date-${date}`}>
            <UpcomingEventCard
              key={index}
              imgSrc={bannerImageURL}
              rewardTitle={description}
              rewardDesc={label}
              date={date}
              timer={timeInterval}
              startTime={startTime}
              endTime={endTime}
            />
          </div>
        );
      })}
    </div>
  );
};

const UpcomingEvent: FC<UpcomingEventProps> = ({ variant, data }): JSX.Element => {
  return <>{getUpcomingEventsDom(variant, data)}</>;
};

export default UpcomingEvent;
